import FrontContainer from './FrontContainer';
export default FrontContainer;